import {AutocompleteAjaxSeeker} from "@ui-seeker/core";
import React from "react";
import {markets} from "../../@signals";


export default function AppMarketsAutocomplete({ ...props}) {

    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
        value={markets.value}
        onChange={e => markets.value = e.target.value}
        label="Market"
        placeholder="Select a Market"
        {...props}
    />
}